import { Face } from '@/analysis/types';
import { PostTagFilters } from '@/type';
import faceRepository from '@/analysis/face/face-repository';
import postTagRepository from './post-tag-repository';

export default {
  findAllByPost(clientId: number, postId: number, filter: PostTagFilters = {}): Promise<Face[]> {
    return postTagRepository
      .findAll(clientId, {
        postId,
        resourceTypes: ['face'],
        limit: 100,
        ...filter,
      })
      .then((result) => {
        const faceIds = result.items.map(t => t.resourceId);
        if (faceIds.length === 0) return [];
        return faceRepository.findByIds(clientId, faceIds).then(faceResult => faceResult.items);
      });
  },
};
